import styled from 'styled-components';
import { getContrastColor } from '../../utils/colorUtils';

export const Title = styled.h2`
  text-align: center;
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};
  margin-bottom: 20px;
  font-size: 24px;
`;

export const SectionTitle = styled.h3`
  color: ${props => props.accentColor || '#667eea'};
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 10px;
  border-bottom: 2px solid ${props => props.accentColor || '#667eea'};
  padding-bottom: 8px;
`;

export const Text = styled.p`
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 12px;
`;

export const List = styled.ul`
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};
  margin-left: 20px;
  font-size: 14px;
  line-height: 1.6;

  li {
    margin-bottom: 8px;
  }

  strong {
    color: ${props => props.accentColor || '#667eea'};
  }
`;

export const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin: 15px 0;
`;

export const FeatureItem = styled.div`
  background: ${props => props.accentColor ? props.accentColor + '15' : 'rgba(102, 126, 234, 0.15)'};
  padding: 12px;
  border-radius: 6px;
  border-left: 3px solid ${props => props.accentColor || '#667eea'};

  p {
    color: ${props => getContrastColor(props.bgColor || '#ffffff')};
    font-size: 13px;
    margin: 0;
    line-height: 1.4;
  }

  @media (max-width: 600px) {
    grid-column: 1 / -1;
  }
`;
